<script setup>

const props = defineProps({
  onAction: {
    type: Function,
    default: () => {}
  },
  onSettingsAction: {
    type: Function,
    default: () => {}
  },
  onCopyGameLab: {
    type: Function,
    default: () => {}
  },
  onLogAction: {
    type: Function,
    default: () => {}
  },
  onTour: {
    type: Function,
    default: () => {}
  },
  onBack: {
    type: Function,
    default: null
  }

});
</script>

<template>
  <div id="app" class="app-container">
    <div class="header">
      <div class="left-action">
        <div v-if="onBack" class="go-back" @click="onBack">
          <img src="@/assets/images/arrowLeft.svg" />
          <span>{{$t('gameLabs_title')}}</span>
        </div>
        <router-link v-else to="/game-labs">
          <div class="go-back">
            <img src="@/assets/images/arrowLeft.svg" />
            <span>{{$t('gameLabs_title')}}</span>
          </div>
        </router-link>
      </div>
      <div class="right-actions">
        <div class="action-button-group">
          <div class="action-button-item" @click="onTour" >
            <img src="../../assets/images/productTourOutline.svg"/>
          </div>

          <div id="g-step-2" class="action-button-item" @click="onLogAction" >
            <img src="@/assets/images/logIconNewGrey.svg" class="log-icon" />
          </div>

          <div id="g-step-3" class="action-button-item" @click="onCopyGameLab" >
            <img src="@/assets/images/copyOutline.svg" />
          </div>

          <div id="g-step-4" class="action-button-item" @click="onSettingsAction" >
            <img src="@/assets/images/settingsOutline.svg" />
          </div>
        </div>

        <div class="action-primary-button" id="g-step-5" @click="onAction">
          <span>{{$t('save_button')}}</span>
        </div>
      </div>
    </div>

    <div class="container">
      <slot />
    </div>
    <v-tour name="myTour"></v-tour>
  </div>
</template>


<style scoped>
.app-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  background-color: #FCFCFD;
  overflow-y: auto;
}

.header {
  position: fixed;
  width: 100%;
  background-color: #FFFFFF;
  border-bottom: 1px solid #EAECF0;
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
  z-index: 999;
}

.container {
  padding-top: 86px;
  padding-bottom: 30px;
  margin: 0 auto;
  max-width: 1200px;
}

.go-back {
  display: flex;
  flex-direction: row;
  gap: 10px;
  font-size: 12px;
  font-family: euclid_medium, sans-serif;
  cursor: pointer;
}

.right-actions {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.right-actions span {
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
}

.left-action a {
  color: #040C2D;
}

.left-action a:active {
  color: #040C2D;
}

.left-action a:visited {
  color: #040C2D;
}

.left-action a:hover {
  color: #040C2D;
}

.action-link {
  cursor: pointer;
  color: #1C3CD5;
}

.log-icon{
  display: flex;
  cursor: pointer;
  align-self: center;
  width: 16px;
  height: 18px;
}
</style>
